// removed by extract-text-webpack-plugin
module.exports = {"ChannelList__count-loader":"ChannelList__count-loader","channelListCountLoader":"ChannelList__count-loader","ChannelCountAnimation":"ChannelCountAnimation","channelCountAnimation":"ChannelCountAnimation","ChannelList__item__count":"ChannelList__item__count","channelListItemCount":"ChannelList__item__count","ChannelList__item":"ChannelList__item","channelListItem":"ChannelList__item"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/channels/ChannelList.scss
// module id = 719
// module chunks = 0